export function recursiveChangeWidgetId(widgets) {

  if (widgets && !widgets.length) {
    // Если не массив виджетов, а виджет с виджетами
    for (let key in widgets) {
      if (Array.isArray(widgets[key]) && widgets[key].length) {
        widgets[key] = recursiveChangeWidgetId(widgets[key])
      }
    }
    
    if (widgets && widgets['$ID']) {
      widgets['$ID'] = Math.random() + ''
      return widgets
    }
    return
  }
  for (let index = 0; index < widgets.length; index++) {
    for (const key in widgets[index]) {
      if (key === '$ID') {
        widgets[index][key] = Math.random() + ''
      }
      if (Array.isArray(widgets[index][key])) {
        widgets[index][key] = recursiveChangeWidgetId(widgets[index][key])
      }
    }
  }
  return widgets
}